(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDialogController', SSPersonaDialogController);

    SSPersonaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPersona', 'SSProyecto'];

    function SSPersonaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPersona, SSProyecto) {
        var vm = this;

        vm.sSPersona = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPersona.id !== null) {
                SSPersona.update(vm.sSPersona, onSaveSuccess, onSaveError);
            } else {
                SSPersona.save(vm.sSPersona, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPersonaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
